import SingleCar from "../Cars/SingleCar";
import { AnimatePresence } from "framer-motion";
import { Route, Routes, useLocation } from "react-router-dom";
import { lazy, Suspense } from "react";
import Loading from "../Loading/Loading";
const Home = lazy(() => import("../Home/Home"));
const Cars = lazy(() => import("../Cars/Cars"));
const About = lazy(() => import("../About/About"));
const Services = lazy(() => import("../Services/Services"));
const Contact = lazy(() => import("../Contact/Contact"));
const ComingSoon = lazy(() => import("../Messages/ComingSoon"));

export default function AnimatedRoutes() {
  const location = useLocation();

  return (
    <Suspense fallback={<div><Loading/></div>}>
      <AnimatePresence
        mode="wait"
        initial={false}
        onExitComplete={() => window.scrollTo(0, 0)}
      >
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/cars/*" element={<Cars />} />
          <Route path="/about/*" element={<About />} />
          <Route path="/services/*" element={<Services />} />
          <Route path="/comingsoon/*" element={<ComingSoon />} />
          <Route
            path="/contact/*"
            element={
              <Contact
                contactT1="NAME"
                contactT2="EMAIL"
                contactT3="SUBJECT"
                contactT4="MESSAGE"
                input="SUBMIT"
              />
            }
          />
          <Route path="cars/:carId/" exact element={<SingleCar />} />
        </Routes>
      </AnimatePresence>
    </Suspense>
  );
}
